import { IconButton } from "@mui/material"
import { User } from "react-feather"
import { makeStyles } from "@material-ui/core/styles"
import { useState } from "react"
import Toast from "../../../../../assets/shared/ui/notification/Toast"
import { axiosPrivate } from "../../../../../api/axios"

const NavUserInfoImage = (): JSX.Element => {
  const [isUserActive, setIsUserActive] = useState<boolean>(true)
  const [bgColor, setBgColor] = useState<string>("green")

  const useStyles = makeStyles({
    iconButton: {
      border: `2px solid ${bgColor}`,
      boxShadow: `0 0 10px ${bgColor}`,
      "&:hover": {
        boxShadow: `0 0 20px ${bgColor}`
      }
    }
  })
  const classes = useStyles()

  const setUserActive = () => {
    setIsUserActive(true)
    setBgColor("green")
    Toast("Online status changed to active", "success")
  }

  const setUserInactive = () => {
    setIsUserActive(false)
    setBgColor("#FF8503")
    Toast("Online status changed to Inactive", "success")
  }

  const handleClick = async() => {
    const resp = await axiosPrivate.post("rest/update_user_visibility", {"visible": !isUserActive})
    if (resp.data.status !== "SUCCESS")
      Toast(resp.data.status, "error")
    else {
      isUserActive ? setUserInactive() : setUserActive()
    }
  }
  return (
    <IconButton
      aria-label="User"
      onClick={handleClick}
      size="large"
      className={classes.iconButton}
    >
      <User />
    </IconButton>
  )
}

export default NavUserInfoImage
